import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const OurPresence = () => {
  return (
    <>
      <div className="py-lg-5 py-4 bg_gray">
        <Container className="py-4">
          <h2
            className="fw-bold fs_8xl mx-auto letter_spacing mb-3 text-center"
            data-aos="fade-down"
          >
            Our Presence
          </h2>
          <p
            className="fs_md letter_spacing fw-normal lh-base text-black mb-4 text-center"
            data-aos="fade-down"
          >
            We're proud of our wide-spread distribution network, spread across
            various states and cities of India. We firmly believe in making
            healthcare accessible to everyone and slowly, we're moving towards
            our aim of establishing our presence in more regions, to reach as
            many people as we can. Currently, we're operating in districts of
            Haryana, Punjab, Rajasthan, U.P and Delhi/NCR where we partner with
            hospitals, distributors and retailers to ensure the efficient and
            secure delivery of life-saving medications and healthcare products.
          </p>
          <Row>
            <Col lg={8} md={7} className="d-flex justify-content-center">
              <div className="position-relative">
                <img loading="lazy" 
                  src="./img/plus-distribution-presence-across-india.webp"
                  alt="Map of India showing PDPL's distribution network and presence"
                  className="w-100 max_w_500 position-relative h-auto"
                />
                <div
                  className="position-absolute location-wrapper text-center cursor_pointer"
                  style={{ top: "26%", left: "30%" }}
                >
                  <img loading="lazy" 
                    src="./img/plus-distribution-center.webp"
                    width={20}
                    height={20}
                    alt="Pointer indicating Hisar"
                    className="animation"
                    aria-hidden="true"
                  />
                  <span className="location-name text-black position-absolute text-nowrap">
                    Hisar
                  </span>
                </div>

                <div
                  className="position-absolute location-wrapper text-center cursor_pointer"
                  style={{ top: "28%", left: "37%" }}
                >
                  <img loading="lazy" 
                    src="./img/plus-distribution-center.webp"
                    width={20}
                    height={20}
                    alt="Pointer indicating Delhi"
                    className="animation"
                    aria-hidden="true"
                  />
                  <span className="location-name text-black position-absolute text-nowrap">
                    Delhi
                  </span>
                </div>

                <div
                  className="position-absolute location-wrapper text-center cursor_pointer"
                  style={{ top: "26%", left: "35%" }}
                >
                  <img loading="lazy" 
                    src="./img/plus-distribution-center.webp"
                    width={20}
                    height={20}
                    alt="Pointer indicating Gurugram"
                    className="animation"
                    aria-hidden="true"
                  />
                  <span className="location-name text-black position-absolute text-nowrap">
                    Gurugram
                  </span>
                </div>

                <div
                  className="position-absolute location-wrapper text-center cursor_pointer"
                  style={{ top: "37%", left: "50%" }}
                >
                  <img loading="lazy" 
                    src="./img/plus-distribution-center.webp"
                    width={20}
                    height={20}
                    alt="Pointer indicating Noida"
                    className="animation"
                    aria-hidden="true"
                  />
                  <span className="location-name text-black position-absolute text-nowrap">
                    Noida
                  </span>
                </div>

                <div
                  className="position-absolute location-wrapper text-center cursor_pointer"
                  style={{ top: "35%", left: "30%" }}
                >
                  <img loading="lazy" 
                    src="./img/plus-distribution-center.webp"
                    width={20}
                    height={20}
                    alt="Pointer indicating Jaipur"
                    className="animation"
                    aria-hidden="true"
                  />
                  <span className="location-name text-black position-absolute text-nowrap">
                    Jaipur
                  </span>
                </div>

                <div
                  className="position-absolute location-wrapper text-center cursor_pointer"
                  style={{ top: "45%", left: "42%" }}
                >
                  <img loading="lazy" 
                    src="./img/plus-distribution-center.webp"
                    width={20}
                    height={20}
                    alt="Pointer indicating Bhopal"
                    className="animation"
                    aria-hidden="true"
                  />
                  <span className="location-name text-black position-absolute text-nowrap">
                    Bhopal
                  </span>
                </div>

                <div
                  className="position-absolute location-wrapper text-center cursor_pointer"
                  style={{ top: "22%", left: "31%" }}
                >
                  <img loading="lazy" 
                    src="./img/plus-distribution-center.webp"
                    width={20}
                    height={20}
                    alt="Pointer indicating Ludhiana"
                    className="animation"
                    aria-hidden="true"
                  />
                  <span className="location-name text-black position-absolute text-nowrap">
                    Ludhiana
                  </span>
                </div>

                <div
                  className="position-absolute location-wrapper text-center cursor_pointer"
                  style={{ top: "24%", left: "43%" }}
                >
                  <img loading="lazy" 
                    src="./img/plus-distribution-center.webp"
                    width={20}
                    height={20}
                    alt="Pointer indicating Dehradun"
                    className="animation"
                    aria-hidden="true"
                  />
                  <span className="location-name text-black position-absolute text-nowrap">
                    Dehradun
                  </span>
                </div>

                <div
                  className="position-absolute location-wrapper text-center cursor_pointer"
                  style={{ top: "29%", left: "33%" }}
                >
                  <img loading="lazy" 
                    src="./img/plus-distribution-center.webp"
                    width={20}
                    height={20}
                    alt="Pointer indicating Panipat"
                    className="animation"
                    aria-hidden="true"
                  />
                  <span className="location-name text-black position-absolute text-nowrap">
                    Panipat
                  </span>
                </div>
              </div>
            </Col>
            <Col lg={4} md={5} xs={8} className="mt-5" data-aos="fade-left">
              <h3 className="fs_md text-black ">
                <img loading="lazy" 
                  src="./img/plus-distribution-location.svg"
                  alt="Icon representing company warehouse locations"
                  width={30}
                  height={30}
                  className="animation"
                />
                Company Warehouses
              </h3>
              <ul className="mb-0 d-flex flex-column gap-2 list_dots">
                <li className="text-black fs_md mb-0 cursor_pointer position-relative">
                  Panipat
                </li>
                <li className="text-black fs_md mb-0 cursor_pointer position-relative">
                  Delhi
                </li>
                <li className="text-black fs_md mb-0 cursor_pointer position-relative">
                  Gurugram
                </li>
                <li className="text-black fs_md mb-0 cursor_pointer position-relative">
                  Noida
                </li>
                <li className="text-black fs_md mb-0 cursor_pointer position-relative">
                  Hisar
                </li>
                <li className="text-black fs_md mb-0 cursor_pointer position-relative">
                  Jaipur
                </li>
                <li className="text-black fs_md mb-0 cursor_pointer position-relative">
                  Dehradun
                </li>
                <li className="text-black fs_md mb-0 cursor_pointer position-relative">
                  Bhopal
                </li>
                <li className="text-black fs_md mb-0 cursor_pointer position-relative">
                  Ludhiana
                </li>
                <li className="text-black fs_md mb-0 cursor_pointer position-relative">
                Chandigarh
                </li>
                <li className="text-black fs_md mb-0 cursor_pointer position-relative">
                 Yamuna Nagar
                </li>
              </ul>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default OurPresence;
